<div class="faq-content">
  <div
    [ngClass]="[
      isActive
        ? 'faq-content-title faq-content-title--active'
        : 'faq-content-title'
    ]"
    (click)="setBlockNumberHandler(blockNumber)"
  >
    <img src="assets/icons/ArrowRight.svg" alt="arrow" />
    <h3>{{ blockNumber }}. {{ category }}</h3>
  </div>
  <div *ngIf="isActive && categories?.length && articles" [@enterAnimation]>
    <div
      class="faq-content-child"
      *ngFor="let item of articles[category]; let childIndex = index"
    >
      <div
        class="child-title"
        (click)="setChildContent(childIndex, childContent === childIndex)"
      >
        <h5>{{ blockNumber }}.{{ childIndex + 1 }}. {{ item.subject }}</h5>
        <img
          [src]="
            childContent !== childIndex
              ? 'assets/icons/filledArrowDown.svg'
              : 'assets/icons/closeSmall.svg'
          "
          alt="arrow-down"
        />
      </div>
      <ng-container *ngIf="childContent === childIndex && item?.details.length">
        <ng-container *ngFor="let detail of item.details">
          <div class="child-content">
            <img
              *ngIf="isPictureAndIsIdNumber(detail) && !!attachmentCache[detail.value]"
              [src]="attachmentCache[detail.value].content | base64: attachmentCache[detail.value].contentType"
              alt="faq_image"
              class="child-image"
            />
            <p
              *ngIf="detail.detailType.code === 'subtitle'"
              class="child-text"
              [innerHTML]="detail.value"
            ></p>
            <div
              class="child-list"
              *ngIf="detail.detailType.code === 'response' || detail.detailType.code === 'text_block'"
            >
              <span *ngFor="let line of detail.value.split('\n')">
                <p [innerHTML]="line"><br /></p>
              </span>
            </div>
            <a
              *ngIf="detail.detailType.code === 'hyperlink'"
              class="child-link"
              [href]="detail.value"
              target="_blank"
            >
              <p [innerHTML]="detail.detailType.name"></p>
            </a>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
